const dictionary = [
    'ultra',
    'glaze',
    'gloss',
    'metallic',
    'timber',
    'print',
    'grain',
    'grains',
    'matt',
    'matte',
    'sheen',
    'fine',
    'solid',
];

const shortestWordLength = 4;
// set for fast lookup
const dictSet = new Set(dictionary.map((w) => w.toLowerCase()));

export const tokenizeString = (input: string): string => {
    const result: string[] = [];
    let index = 0;

    while (index < input.length) {
        let matchFound = false;

        for (
            let currentLength = input.length - index;
            currentLength >= shortestWordLength;
            currentLength--
        ) {
            const substring = input.substring(index, index + currentLength);
            const lowerSubstring = substring.toLowerCase();

            if (dictSet.has(lowerSubstring)) {
                result.push(substring);
                index += currentLength;
                matchFound = true;
                break;
            }
        }

        // Unknown words as a single block
        if (!matchFound) {
            // Find where the next known dictionary word starts
            let nextMatchIndex = input.length;

            for (
                let i = index + 1;
                i <= input.length - shortestWordLength;
                i++
            ) {
                // Check if any dictionary word starts at position 'i'
                for (const word of dictionary) {
                    if (
                        input.substring(i, i + word.length).toLowerCase() ===
                        word
                    ) {
                        nextMatchIndex = i;
                        break;
                    }
                }
                if (nextMatchIndex !== input.length) break;
            }

            const unknownBlock = input.substring(index, nextMatchIndex);
            result.push(unknownBlock);
            index = nextMatchIndex;
        }
    }

    return result.join(' ').replace(/\s+/g, ' ').trim();
};
